import { Search, TrendingUp, Compass, Wallet, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import CtaButton from "./CtaButton";
import RegisterButton from "./RegisterButton";

const MODULES = [
    {
        no: "01",
        icon: Search,
        tone: "text-volt",
        ring: "border-volt/30 bg-volt/10",
        blob: "bg-volt/10",
        title: "WHAT IS ENGULFING?",
        body: "Kenali teknik Engulfing dan belajar cara mengenal pasti bullish serta bearish engulfing pada chart.",
    },
    {
        no: "02",
        icon: TrendingUp,
        tone: "text-flame",
        ring: "border-blood/30 bg-blood/10",
        blob: "bg-blood/10",
        title: "HOW TO USE ENGULFING IN TRADING",
        body: "Fahami bagaimana Engulfing boleh digunakan dalam analisis market dan sebagai salah satu confirmation sebelum entry.",
    },
    {
        no: "03",
        icon: Compass,
        tone: "text-volt",
        ring: "border-volt/30 bg-volt/10",
        blob: "bg-volt/10",
        title: "HOW TO READ TRENDS USING ENGULFING",
        body: "Belajar cara membaca trend dan memahami market structure menggunakan teknik Engulfing.",
    },
    {
        no: "04",
        icon: Wallet,
        tone: "text-white",
        ring: "border-white/30 bg-white/10",
        blob: "bg-white/5",
        title: "MONEY MANAGEMENT",
        body: "Fahami asas risk management, position sizing dan cara mengurus modal dengan lebih berdisiplin.",
    },
];

const Modules = () => (
    <section data-testid="modules-section" className="relative py-24 md:py-32">
        <div className="pointer-events-none absolute left-0 top-1/3 h-[420px] w-[420px] rounded-full bg-blood/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-flame">
                    Kandungan seminar
                </p>
                <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-6xl">
                    APA YANG KORANG AKAN BELAJAR? 🔥
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-5 md:grid-cols-2">
                {MODULES.map((m, i) => (
                    <Reveal key={m.no} delay={0.08 * i}>
                        <div
                            data-testid={`module-card-${i + 1}`}
                            className="card-luxe group relative h-full overflow-hidden rounded-3xl p-8 transition duration-300 hover:-translate-y-1 hover:border-white/30 md:p-10"
                        >
                            <div
                                className={`pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full ${m.blob} blur-2xl transition duration-300 group-hover:scale-125`}
                            />
                            <div className="relative flex items-start justify-between">
                                <span
                                    className={`inline-flex rounded-2xl border p-3.5 ${m.ring}`}
                                >
                                    <m.icon size={24} className={m.tone} />
                                </span>
                                <span className="font-mono text-sm tracking-[0.2em] text-white/25">
                                    MODULE_{m.no}
                                </span>
                            </div>
                            <h3 className="relative mt-8 font-display text-xl font-extrabold tracking-tight text-white md:text-2xl">
                                {m.title}
                            </h3>
                            <p className="relative mt-4 leading-relaxed text-white/65">
                                {m.body}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <div className="mt-12 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
                    <CtaButton location="Middle" testId="middle-cta-button">
                        PM Admin Telegram
                    </CtaButton>
                    <RegisterButton testId="middle-register-button" />
                    <p className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-white/50">
                        <ArrowRight size={14} className="text-flame" />
                        Dua cara mudah — pilih yang anda suka
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Modules;
